import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "animate.css";
import "leaflet/dist/leaflet.css";

import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";

import axios from "axios";
import VueAxios from "vue-axios";

import { createI18n } from "vue-i18n";
import en from "./languages/en-US.json";
import ja from "./languages/ja-JP.json";
import zh from "./languages/zh-TW.json";

import { defineRule, configure } from "vee-validate";
import { required, email, min } from "@vee-validate/rules";
import { localize, setLocale } from "@vee-validate/i18n";
import zh_TW from "./plugins/vee-validate/zh_TW.json";

import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// import { VueQueryPlugin } from "@tanstack/vue-query";

import * as bootstrap from "bootstrap";

// 全局設定 AJAX 攔截器 (interceptor)
import interceptor from "./plugins/axios/interceptor";

const app = createApp(App);

// vee-validate
defineRule("required", required);
defineRule("email", email);
defineRule("min", min);

configure({
  validateOnInput: true,
  generateMessage: localize({
    zh_TW,
  }),
});
setLocale("zh_TW");

// i18n
const i18n = createI18n({
  legacy: false, // 要把 legacy 設為 false，才可以使用 Composition API
  locale: "zh-TW",
  fallbackLocale: "zh-TW",
  globalInjection: true,
  messages: {
    "en-US": en,
    "ja-JP": ja,
    "zh-TW": zh,
  },
});

app.use(createPinia());
app.use(router);
app.use(VueAxios, axios);
app.use(i18n);
app.use(LoadingPlugin);
app.use(VueSweetalert2);
// app.use(VueQueryPlugin);

app.mount("#app");
